import { render, staticRenderFns } from "./Ksetting.vue?vue&type=template&id=2ae46ccd"
import script from "./Ksetting.vue?vue&type=script&lang=js"
export * from "./Ksetting.vue?vue&type=script&lang=js"
import style0 from "./Ksetting.vue?vue&type=style&index=0&id=2ae46ccd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports